import React from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { get, useFormContext } from "react-hook-form";
import "./TextArea.scss";
import { FormattedMessage } from "react-intl";

interface TextareaProps {
  name: string;
  required?: boolean;
  errorMsg?: string;
  defaultValue?: string;
  placeholder?: string;
  rows?: number;
  className?: string;
  eventContext?: string;
  eventName?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  style?: React.CSSProperties;
  validations?: object;
  v2?: boolean;
  minHeight?: string;
  testId?: string;
}

const Textarea = function ({
  name,
  required,
  errorMsg,
  defaultValue,
  eventContext: _eventContext,
  eventName: _eventName,
  onBlur,
  className,
  style,
  validations,
  v2,
  minHeight,
  testId,
  ...props
}: TextareaProps) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  function constructErrorName() {
    let n: string[] = name.split(/[[.]+/).join(",").split(/]|,/);
    n = n.filter((each: string) => each.length > 0);
    return errors?.[n[0]]?.[n[1]]?.[n[2]];
  }

  const errorClass = (required && constructErrorName()) || get(errors, name) ? "is-invalid" : "";

  return (
    <div>
      <Form.Control
        data-testid={testId || `textarea-${name.replace(/[.[\]]+/g, "-").replace(/-+$/g, "")}`}
        style={{ ...style, minHeight }}
        as="textarea"
        defaultValue={defaultValue}
        {...register(name, { required, ...validations })}
        className={className ? `${className} ${errorClass} br-10` : `${errorClass} textarea-v2`}
        onBlur={onBlur}
        {...props}
      />
      {get(errors, name) && (
        <div className="d-block font-b3 invalid-feedback">
          {get(errors, name)?.message ? (
            get(errors, name).message
          ) : (
            <FormattedMessage id="general.requiredField" defaultMessage="This is a required field" />
          )}
        </div>
      )}
    </div>
  );
};

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  errorMsg: PropTypes.string,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  eventContext: PropTypes.string,
  eventName: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  minHeight: PropTypes.string,
  testId: PropTypes.string,
};

Textarea.defaultProps = {
  v2: false,
  required: false,
  errorMsg: "Please enter a value",
  defaultValue: "",
  placeholder: "",
  rows: 0,
  className: "",
  eventContext: "Quote Request Form",
  eventName: "",
  onBlur: () => {},
  onFocus: () => {},
  style: {},
  validations: null,
  minHeight: "128px",
  testId: "",
};

export default Textarea;
